import { Checkbox as MantineCheckbox, CheckboxProps } from '@mantine/core';

export type ICheckboxProps = CheckboxProps;

/** @registry Design-layer pass-through over Mantine Checkbox; import this instead of @mantine/core Checkbox outside src/design. Extend here when Checkbox needs house behavior. */
export const Checkbox = MantineCheckbox;
